import { format } from "date-fns";
import { Button } from "@/components/ui/button";
import { Check, Eye } from "lucide-react";
import { openSafePdfPopup } from "@/lib/safePopup";

// Customer Signature status row that lives above the executed-doc drop
// zone in the WO form. Shows the "Signature Required" toggle, the
// current sign state (Signed / Awaiting / Not Required), and a link to
// view the executed PDF (when present).  Extracted from
// WorkOrderTab.jsx (Feb 2026, iter174).
export function WOSignatureBlock({ form, setForm, editingWO }) {
  if (!editingWO) return null;
  return (
    <div className="border-t pt-3 flex items-center gap-3 flex-wrap">
      <label
        className="flex items-center gap-1.5 text-xs text-slate-500 cursor-pointer"
        data-testid="signature-required-toggle"
      >
        <input
          type="checkbox"
          checked={form.signature_required}
          onChange={(e) => setForm({ ...form, signature_required: e.target.checked })}
          className="rounded border-slate-300 text-blue-600 focus:ring-blue-500 h-3.5 w-3.5"
        />
        Signature Required
      </label>
      {editingWO.signature_data ? (
        <>
          <span
            className="text-xs text-green-600 font-semibold flex items-center gap-1 bg-green-50 px-2 py-0.5 rounded-full"
            data-testid="wo-executed-badge"
          >
            <Check className="w-3.5 h-3.5" /> Signed
          </span>
          <span className="text-[10px] text-slate-400">
            Signed by {editingWO.signed_by || "N/A"}{" "}
            {editingWO.signed_at ? `on ${format(new Date(editingWO.signed_at), "MMM d, yyyy")}` : ""}
          </span>
        </>
      ) : form.signature_required ? (
        <span
          className="text-xs text-amber-600 font-medium flex items-center gap-1 bg-amber-50 px-2 py-0.5 rounded-full"
          data-testid="wo-awaiting-signature"
        >
          Awaiting Signature
        </span>
      ) : editingWO.proposal_id ? (
        <span className="text-xs text-slate-400 italic">
          Not required — WO converted from signed proposal
        </span>
      ) : (
        <span className="text-xs text-slate-400 italic">Not required</span>
      )}
      {editingWO.executed_wo_pdf && (
        <Button
          variant="outline"
          size="sm"
          className="h-6 text-[10px] px-2 ml-auto gap-1"
          onClick={() => {
            // Centralized `openSafePdfPopup` so no user-controlled
            // string (wo_number, executed_wo_pdf URL) is interpolated
            // into an HTML string (XSS hardening — iter170).
            openSafePdfPopup({
              title: `${form.wo_number || "WO"} - Executed`,
              src: editingWO.executed_wo_pdf,
            });
          }}
          data-testid="btn-view-executed-wo"
        >
          <Eye className="w-3 h-3" /> View Executed WO
        </Button>
      )}
    </div>
  );
}
